import React from "react";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";

const AppCustomTooltip = ({ Title, Placement, children }) => {
  const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      fontSize: 13,
      fontFamily: "Inter",
    },
  }));

  return (
    <CustomTooltip title={Title} placement={Placement}>
      {children}
    </CustomTooltip>
  );
};

export default AppCustomTooltip;
